// extracted by mini-css-extract-plugin
export default {"customisedSlide":"CustomisedSlide_customisedSlide__ah90J","description":"CustomisedSlide_description__Fig9H"};